"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemLocationAvailability;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@bluefin/components");
var _ItemLocationAvailability = require("./ItemLocationAvailability.utils");
var _ = require("../..");
var _templateUtils = require("../../template-utils");
var _location = require("../../types/location");
var _service = require("../../types/service");
var _utils = require("../../utils");
var propTypes = {
  as: _propTypes["default"].string,
  className: _propTypes["default"].string,
  item: _service.CatalogItemPropType.isRequired,
  locations: _propTypes["default"].arrayOf(_location.LocationPropType)
};
var defaultProps = {
  as: 'span',
  className: '',
  locations: []
};
function ItemLocationAvailability(_ref) {
  var as = _ref.as,
    item = _ref.item,
    locations = _ref.locations,
    className = _ref.className;
  var _item$locations = item.locations,
    itemLocations = _item$locations === void 0 ? [] : _item$locations;
  var locationsWithAvailability = (0, _ItemLocationAvailability.getItemLocations)(itemLocations, locations);
  var locationCount = locationsWithAvailability.length;
  var isAvailableInAllLocations = locationCount === locations.length;
  if (locationCount === 0 || isAvailableInAllLocations) {
    return null;
  }
  var finalClassName = "item-location-availability".concat(className ? " ".concat(className) : '');
  var locationLinks = locationsWithAvailability.map(function (location) {
    var locationId = location._id;
    return /*#__PURE__*/_react["default"].createElement(_components.InternalLink, {
      key: locationId,
      label: (0, _templateUtils.createLocationName)(location),
      to: (0, _.createLocationSlug)(location, locations)
    });
  });
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("strong", null, "Offered at:"), " ", (0, _utils.createCommaSeparatedList)(locationLinks));
  return /*#__PURE__*/_react["default"].createElement(as, {
    className: finalClassName
  }, content);
}
ItemLocationAvailability.propTypes = propTypes;
ItemLocationAvailability.defaultProps = defaultProps;